import { useTranslation } from 'react-i18next';

import { i18nNameSpace } from '@shared/consts/i18n.ts';
import { ApiError } from '@shared/utils/interfaces/error.ts';
import { translateApiErrorFieldPath } from '@shared/utils/translateApiErrorFieldPath.ts';

import styles from './ErrorMessage.module.scss';

interface ErrorToastMessageProps {
  error: ApiError | string;
}

function ErrorMessageText({ error }: ErrorToastMessageProps) {
  const { t } = useTranslation(i18nNameSpace.API);

  if (typeof error === 'string') {
    return <span className={styles.text}>{t(error)}</span>;
  }

  const { key, props: translationProps } = error.i18n;
  const existingTranslationProps = translationProps ?? {};
  const rawFieldPath = existingTranslationProps.fieldPath;
  const interpolatedProps = {
    ...existingTranslationProps,
    ...(typeof rawFieldPath === 'string' ? { fieldPath: translateApiErrorFieldPath(rawFieldPath) } : {}),
  };

  return <span className={styles.text}>{t(key, interpolatedProps)}</span>;
}

export function ErrorMessage({ error }: ErrorToastMessageProps) {
  const { t } = useTranslation(i18nNameSpace.API);

  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>{t('api.error.common.toastHeaderText')}</p>
      <ErrorMessageText error={error} />
    </div>
  );
}
